import { useTranslation } from 'react-i18next';
import { Progress } from '@/components/ui/progress';

interface QuickStatsProps {
  projectCount: number;
  activeSessions: number;
  maxSessions: number;
  maxCpu: number;
  maxRam: number;
}

export function QuickStats({ projectCount, activeSessions, maxSessions, maxCpu, maxRam }: QuickStatsProps) {
  const { t } = useTranslation('dashboard');

  return (
    <div className="space-y-3">
      <div className="bg-surface-1 rounded-lg border p-4">
        <p className="text-sm text-muted-foreground">{t('quickStats.projects')}</p>
        <p className="text-2xl font-heading font-semibold">{projectCount}</p>
      </div>

      <div className="bg-surface-1 rounded-lg border p-4">
        <p className="text-sm text-muted-foreground">{t('quickStats.activeSessions')}</p>
        <p className="text-2xl font-heading font-semibold">
          {activeSessions}/{maxSessions}
        </p>
        <Progress
          value={maxSessions > 0 ? Math.round((activeSessions / maxSessions) * 100) : 0}
          className="h-1.5 mt-2"
        />
      </div>

      <div className="bg-surface-1 rounded-lg border p-4">
        <p className="text-sm text-muted-foreground">{t('quickStats.resources')}</p>
        <p className="text-2xl font-heading font-semibold">
          {t('quickStats.resourceValue', { count: maxCpu, maxCpu, maxRam })}
        </p>
      </div>
    </div>
  );
}
